var _style, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMotionLogoWeb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 758 171",
    style: {
      enableBackground: "new 0 0 758 171"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st90{fill:url(#SVGID_10_);}\n\t.st80{fill:url(#SVGID_20_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 379,
    y1: 15.3042,
    x2: 379,
    y2: 169.9442,
    gradientTransform: "matrix(1 0 0 -1 0 170.0884)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0047BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#01BEDB"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st90",
    d: "M212.3,106.2v45.5H182v-45.5c0-25.1-20.3-45.4-45.4-45.5c9.5,12.7,15.1,28.4,15.1,45.5v45.5h-30.3v-45.5 c0-13.5-5.8-25.5-15.1-33.9c-8-7.2-18.7-11.6-30.3-11.6l0,0c-25.1,0-45.4,20.4-45.4,45.5v45.5H0.3v-45.5 c0-41.8,33.9-75.8,75.8-75.8c10.8,0,21,2.2,30.3,6.3c9.3-4.1,19.5-6.3,30.3-6.3C178.4,30.4,212.3,64.3,212.3,106.2z M454.8,45.6 v106.1H485V45.6C475,47.6,464.7,47.6,454.8,45.6z M454.8,0.1V30c9.9,2.6,20.4,2.6,30.3,0V0.1H454.8z M697.2,30.4 c-33.5,0-60.6,27.1-60.6,60.6v60.6h30.3V91c0-16.7,13.6-30.3,30.3-30.3s30.3,13.6,30.3,30.3v60.6h30.3V91 C757.8,57.6,730.7,30.4,697.2,30.4z M622.9,92.5c0,34.3-27.8,62.1-62.1,62.1s-62.1-27.8-62.1-62.1s27.8-62.1,62.1-62.1 C595,30.4,622.9,58.2,622.9,92.5z M592.5,92.5c0-17.6-14.2-31.8-31.8-31.8S529,75,529,92.5c0,17.6,14.2,31.8,31.8,31.8 C578.4,124.4,592.5,110.1,592.5,92.5z M394,0.1h-30.3c0,41.8,33.9,75.8,75.8,75.8V45.6C414.5,45.6,394,25.2,394,0.1z M76,68.3 c-1.8,0-3.5,0.1-5.2,0.4c-6.3,11.1-9.9,23.9-9.9,37.5v45.5h30.3v-45.5c0-10.7,3.7-20.6,9.9-28.4C94.3,71.9,85.6,68.3,76,68.3z  M405,117.3c-7.1-6-10.8-14.6-10.8-23.2V70c-6.2-4-11.7-8.8-16.6-14.3c-5.5-6.2-10.2-13.2-13.7-20.8v59.2 c0,17.3,7.4,34.5,21.6,46.4c2.7,2.3,5.6,4.3,8.6,6.1c14,8.1,30.4,10.1,45.5,6.2v-32.4C428.9,126.5,415,125.7,405,117.3z  M260.2,120.4c-13.2-13.2-24.4-26.8-33.1-39.7c-3.8,19.6,1.9,40.6,17.1,55.8s36.2,20.9,55.8,17.1 C287.1,144.8,273.5,133.6,260.2,120.4z M346.6,113.4c7.8-21.9,2.9-47.3-14.6-64.8S289.1,26.2,267.2,34c-4,1.4-7.8,3.3-11.5,5.5 c2,6.1,7.7,15.3,16,25.7c12.2-7.4,28.4-5.8,38.9,4.8s12.1,26.7,4.8,38.9c10.5,8.3,19.6,14,25.7,16 C343.4,121.3,345.2,117.4,346.6,113.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 497.475,
    y1: -7.3308,
    x2: 275.325,
    y2: 214.8192,
    gradientTransform: "matrix(1 0 0 -1 0 170.0884)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#CC007E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D9409E"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st80",
    d: "M363.1,167.5c-12.4,12.4-56.1-11.1-97.5-52.5s-64.9-85.1-52.5-97.5c7.4-7.4,25.6-2.1,47.9,12 c-5.9-2.2-10.3-2.4-12.6-0.2c-7.1,7.1,10.2,35.9,38.6,64.3s57.2,45.7,64.3,38.6c2.2-2.2,2.1-6.7-0.2-12.6 C365.2,141.9,370.4,160.2,363.1,167.5z M560.8,77.4c-8.4,0-15.2,6.8-15.2,15.2s6.8,15.2,15.2,15.2S576,101,576,92.6 S569.2,77.4,560.8,77.4z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotionLogoWeb);
export default __webpack_public_path__ + "static/media/motion-logo-web.3d76abd5.svg";
export { ForwardRef as ReactComponent };